(function() {
  const ROOT = "uca-addons-widget[data-uca-addons-root]";
  const RADIO = "[data-uca-radio]";
  const OPTION = "[data-uca-option]";
  let variantBaseCents = null;
  let nowTimer = null;
  let lateTimer = null;
  let variantWatchBound = false;
  let avisWatchBound = false;
  let ucaClickBound = false;
  let ucaChangeBound = false;
  let ucaKeydownBound = false;
  const DEFAULT_UCA_BASE_TITLE = "Upper Control Arms";
  const num = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.round(parsed) : 0;
  };
  const text = (value) => typeof value === "string" ? value.trim() : "";
  const UCA_GROUP_SUFFIXES = Object.freeze({
    optional: "Optional",
    recommended: "Recommended",
    stronglyRecommended: "Strongly Recommended"
  });
  const normalizeUcaBaseLabel = (value) => text(value).replace(/\s+\((?:Optional|Recommended|Strongly Recommended)\)$/i, "") || DEFAULT_UCA_BASE_TITLE;
  const buildUcaGroupLabel = (baseLabel, suffix) => `${normalizeUcaBaseLabel(baseLabel)} (${suffix})`;
  const parseLiftHeight = (value) => {
    const match = text(value).replace(/,/g, ".").match(/(\d+(?:\.\d+)?)/);
    if (!match) return null;
    const parsed = Number(match[1]);
    return Number.isFinite(parsed) ? parsed : null;
  };
  const getLiftSelection = () => {
    var _a, _b, _c;
    const form = document.querySelector("variant-form-custom");
    const liftGroup = form == null ? void 0 : form.querySelector(".selector--lift");
    if (!liftGroup) return "";
    const checkedValue = text((_a = liftGroup.querySelector("input.single-option-selector:checked")) == null ? void 0 : _a.value) || text((_b = liftGroup.querySelector("input:checked")) == null ? void 0 : _b.value);
    if (checkedValue) return checkedValue;
    const optionIndex = Number(liftGroup.dataset.optionIndex);
    if (Number.isInteger(optionIndex) && Array.isArray((_c = form == null ? void 0 : form.currentVariant) == null ? void 0 : _c.options)) {
      return text(form.currentVariant.options[optionIndex]);
    }
    if (Number.isInteger(optionIndex) && Array.isArray(form == null ? void 0 : form.options)) {
      return text(form.options[optionIndex]);
    }
    return "";
  };
  const getUcaGroupSuffixForLift = (liftValue = getLiftSelection()) => {
    const liftHeight = parseLiftHeight(liftValue);
    if (liftHeight == null || liftHeight < 2.5) {
      return UCA_GROUP_SUFFIXES.optional;
    }
    if (liftHeight >= 3) {
      return UCA_GROUP_SUFFIXES.stronglyRecommended;
    }
    return UCA_GROUP_SUFFIXES.recommended;
  };
  const widgets = () => Array.from(document.querySelectorAll(ROOT));
  const getUcaBaseLabel = (widget = null) => {
    var _a, _b, _c, _d, _e, _f;
    return normalizeUcaBaseLabel(
      ((_a = widget == null ? void 0 : widget.dataset) == null ? void 0 : _a.ucaGroupBaseLabel) || ((_b = widget == null ? void 0 : widget.dataset) == null ? void 0 : _b.ucaGroupLabel) || ((_d = (_c = widgets()[0]) == null ? void 0 : _c.dataset) == null ? void 0 : _d.ucaGroupBaseLabel) || ((_f = (_e = widgets()[0]) == null ? void 0 : _e.dataset) == null ? void 0 : _f.ucaGroupLabel) || DEFAULT_UCA_BASE_TITLE
    );
  };
  const getUcaGroupLabelForLift = (baseLabel = getUcaBaseLabel(), liftValue = getLiftSelection()) => buildUcaGroupLabel(baseLabel, getUcaGroupSuffixForLift(liftValue));
  const buildPreviewThumb = (src, alt = "") => {
    if (!src) return null;
    const wrapper = document.createElement("span");
    wrapper.className = "inline-flex h-[55.867px] w-[55.867px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[0.61px] border-[#E5E5E5] bg-white";
    const image = document.createElement("img");
    image.src = src;
    image.alt = alt;
    image.loading = "lazy";
    image.className = "block h-full w-full object-contain";
    wrapper.appendChild(image);
    return wrapper;
  };
  const ACCORDION_CLOSED_Y = "-8px";
  const ACCORDION_OPEN_Y = "0px";
  const ACCORDION_TRANSITION = "height 260ms cubic-bezier(0.22, 1, 0.36, 1), opacity 180ms ease-out, transform 260ms cubic-bezier(0.22, 1, 0.36, 1)";
  const setHiddenState = (element, hidden) => {
    if (!element) return;
    element.hidden = hidden;
    element.classList.toggle("hidden", hidden);
  };
  const clearAccordionAnimation = (body) => {
    if (!body) return;
    if (body.__accordionFrame) {
      cancelAnimationFrame(body.__accordionFrame);
      body.__accordionFrame = null;
    }
    if (typeof body.__accordionCleanup === "function") {
      body.__accordionCleanup();
      body.__accordionCleanup = null;
    }
  };
  const finalizeAccordionState = (body, expanded) => {
    if (!body) return;
    clearAccordionAnimation(body);
    setHiddenState(body, !expanded);
    body.style.overflow = "hidden";
    body.style.height = expanded ? "auto" : "0px";
    body.style.opacity = expanded ? "1" : "0";
    body.style.transform = expanded ? `translateY(${ACCORDION_OPEN_Y})` : `translateY(${ACCORDION_CLOSED_Y})`;
    body.style.willChange = "";
  };
  const syncAccordionBody = (body, expanded, { immediate = false } = {}) => {
    if (!body) return;
    clearAccordionAnimation(body);
    body.style.transition = ACCORDION_TRANSITION;
    body.style.overflow = "hidden";
    if (immediate) {
      finalizeAccordionState(body, expanded);
      return;
    }
    setHiddenState(body, false);
    const startHeight = expanded ? body.getBoundingClientRect().height : body.getBoundingClientRect().height || body.scrollHeight;
    const targetHeight = expanded ? body.scrollHeight : 0;
    body.style.willChange = "height, opacity, transform";
    body.style.height = `${startHeight}px`;
    body.style.opacity = expanded && startHeight === 0 ? "0" : "1";
    body.style.transform = expanded ? `translateY(${ACCORDION_CLOSED_Y})` : `translateY(${ACCORDION_OPEN_Y})`;
    void body.offsetHeight;
    body.__accordionCleanup = () => {
      body.removeEventListener("transitionend", handleTransitionEnd);
    };
    function handleTransitionEnd(event) {
      if (event.target !== body || event.propertyName !== "height") return;
      finalizeAccordionState(body, expanded);
    }
    body.addEventListener("transitionend", handleTransitionEnd);
    body.__accordionFrame = requestAnimationFrame(() => {
      body.style.height = `${targetHeight}px`;
      body.style.opacity = expanded ? "1" : "0";
      body.style.transform = expanded ? `translateY(${ACCORDION_OPEN_Y})` : `translateY(${ACCORDION_CLOSED_Y})`;
    });
  };
  const createSummaryClone = (option) => {
    if (!option) return null;
    const clone = option.cloneNode(true);
    clone.removeAttribute("data-uca-option");
    clone.classList.add("pointer-events-none");
    clone.querySelectorAll(RADIO).forEach((input) => input.remove());
    clone.querySelectorAll("[data-addon-details-trigger]").forEach((trigger) => trigger.remove());
    return clone;
  };
  const selectedFromWidget = (widget) => {
    var _a;
    if (!widget) return null;
    if (typeof widget.getSelectedItemData === "function") {
      return widget.getSelectedItemData();
    }
    const radio = widget.querySelector(`${RADIO}:checked`);
    const id = text((_a = radio == null ? void 0 : radio.dataset) == null ? void 0 : _a.ucaAddonId);
    if (!id) return null;
    return {
      id: num(id),
      quantity: 1,
      priceCents: num(radio.dataset.ucaAddonPrice),
      heading: text(radio.dataset.ucaAddonHeading),
      label: text(radio.dataset.ucaAddonLabel),
      group: text(radio.dataset.ucaAddonGroup) || text(widget.dataset.ucaGroupLabel) || getUcaGroupLabelForLift(getUcaBaseLabel(widget))
    };
  };
  const selectedItems = () => widgets().map(selectedFromWidget).filter(Boolean).map((item) => ({
    id: item.id,
    quantity: item.quantity,
    priceCents: item.priceCents,
    properties: {
      "_Addon Type": "Upper Control Arms",
      "_UCA Group": item.group,
      "_UCA Heading": item.heading,
      "_UCA Option": item.label
    }
  }));
  const selectedTotal = () => selectedItems().reduce((sum, item) => sum + num(item.priceCents), 0);
  const formatMoney = (cents) => {
    var _a, _b;
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        window.shopCurrencyFormat || "${{amount}}"
      );
    }
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: ((_b = (_a = window.Shopify) == null ? void 0 : _a.currency) == null ? void 0 : _b.active) || "USD"
    });
  };
  const parseMoneyToCents = (value) => {
    const normalized = String(value || "").replace(/[^0-9.,-]/g, "").replace(/,/g, "");
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  };
  const mainVariantId = () => {
    var _a, _b, _c;
    return num(
      ((_b = (_a = document.querySelector("variant-form-custom")) == null ? void 0 : _a.currentVariant) == null ? void 0 : _b.id) || ((_c = document.querySelector(
        "product-form form[data-type='add-to-cart-form'] input[name='id'], form[id^='product-form-'] input[name='id'], [data-lk-sticky-form] input[name='id'], variant-form-custom select[name='id']"
      )) == null ? void 0 : _c.value)
    );
  };
  const getDisplayPriceTargets = () => Array.from(
    new Set(
      [
        ...document.querySelectorAll(".price-box .price-item--regular"),
        ...document.querySelectorAll("[data-lk-summary-price] [data-lk-current-price]"),
        ...document.querySelectorAll("[data-lk-sticky] [data-lk-current-price]")
      ].filter(Boolean)
    )
  );
  const variantBase = () => {
    var _a, _b, _c, _d;
    const fromEvent = num((_a = window.__lastVariantChange) == null ? void 0 : _a.price);
    if (fromEvent > 0) return variantBaseCents = fromEvent;
    const fromMap = num((_c = (_b = window.VARIANT_PRICE_MAP) == null ? void 0 : _b[mainVariantId()]) == null ? void 0 : _c.price);
    if (fromMap > 0) return variantBaseCents = fromMap;
    if (num(variantBaseCents) > 0) return num(variantBaseCents);
    return parseMoneyToCents(
      (_d = document.querySelector(
        "[data-lk-summary-price] [data-lk-current-price], .price-box .price-item--regular, .regular-price.price-item--regular"
      )) == null ? void 0 : _d.textContent
    );
  };
  const avisTotal = () => {
    var _a;
    return num((_a = document.querySelector(".apo-total-addcharge")) == null ? void 0 : _a.value);
  };
  const tireTotal = () => {
    var _a, _b;
    const apiTotal = num((_b = (_a = window.TireWidgetAddon) == null ? void 0 : _a.getSelectedTotalCents) == null ? void 0 : _b.call(_a));
    if (apiTotal > 0) return apiTotal;
    const widget = document.querySelector("tire-widget");
    if (widget && typeof widget.getSelectedAddonCents === "function") {
      return num(widget.getSelectedAddonCents());
    }
    return 0;
  };
  const moreAddonsTotal = () => {
    if (window.MudifyMoreAddons && typeof window.MudifyMoreAddons.getSelectedTotalCents === "function") {
      return num(window.MudifyMoreAddons.getSelectedTotalCents());
    }
    return Array.from(document.querySelectorAll("[data-more-addons-total]")).reduce(
      (sum, input) => {
        var _a;
        return sum + num((input == null ? void 0 : input.value) || ((_a = input == null ? void 0 : input.dataset) == null ? void 0 : _a.value));
      },
      0
    );
  };
  const frontShockAssemblyTotal = () => {
    if (window.MudifyFrontShockAssembly && typeof window.MudifyFrontShockAssembly.getSelectedTotalCents === "function") {
      return num(window.MudifyFrontShockAssembly.getSelectedTotalCents());
    }
    return 0;
  };
  const hasAddonRuntime = () => Boolean(
    widgets().length || document.querySelector(".apo-total-addcharge") || document.querySelector(".avpoptions-container__v2") || document.querySelector("tire-widget") || document.querySelector("[data-more-addons-total]") || document.querySelector("[data-fsa-addon]")
  );
  const combinedTotal = (baseCents = null) => {
    const base = baseCents == null ? variantBase() : num(baseCents);
    return Math.max(
      0,
      base + avisTotal() + selectedTotal() + tireTotal() + moreAddonsTotal() + frontShockAssemblyTotal()
    );
  };
  const applyCombinedPrice = (baseCents = null) => {
    if (!hasAddonRuntime()) return null;
    const total = combinedTotal(baseCents);
    const formatted = formatMoney(total);
    getDisplayPriceTargets().forEach((element) => {
      var _a;
      const prefix = ((_a = element.dataset) == null ? void 0 : _a.lkPricePrefix) || "";
      const normalizedPrefix = prefix.trim();
      element.textContent = normalizedPrefix ? `${normalizedPrefix} ${formatted}` : formatted;
    });
    const sticky = document.querySelector(".sticky-add-to-cart .product-price");
    if (sticky) sticky.textContent = formatted;
    window.__lastPriceChange = { text: formatted, cents: total };
    document.dispatchEvent(
      new CustomEvent("price:change", { detail: window.__lastPriceChange })
    );
    return window.__lastPriceChange;
  };
  const scheduleNow = () => {
    clearTimeout(nowTimer);
    nowTimer = setTimeout(applyCombinedPrice, 0);
  };
  const scheduleLate = () => {
    clearTimeout(lateTimer);
    lateTimer = setTimeout(applyCombinedPrice, 560);
  };
  const emitChange = () => {
    const detail = { items: selectedItems(), totalCents: selectedTotal() };
    window.__lastUcaAddonChange = detail;
    document.dispatchEvent(new CustomEvent("uca:addon-change", { detail }));
    scheduleNow();
    scheduleLate();
  };
  const refresh = (emit = true) => {
    widgets().forEach((widget) => {
      if (typeof widget.refresh === "function") {
        widget.refresh(false);
      }
    });
    if (emit) emitChange();
  };
  const syncWidgetSelectionState = (widget, emit = true) => {
    var _a, _b, _c;
    if (!widget) return;
    const selectedRadio = widget.querySelector(`${RADIO}:checked`);
    widget.__selectedRadio = selectedRadio || null;
    widget.querySelectorAll(OPTION).forEach((option) => {
      const radio = option.querySelector(RADIO);
      const isSelected = Boolean(radio && radio.checked);
      option.classList.toggle("is-selected", isSelected);
      option.setAttribute("aria-checked", isSelected ? "true" : "false");
    });
    const hidden = widget.querySelector(".uca-total-addcharge");
    if (hidden) {
      hidden.value = String(num((_a = selectedRadio == null ? void 0 : selectedRadio.dataset) == null ? void 0 : _a.ucaAddonPrice));
    }
    (_b = widget.syncPreview) == null ? void 0 : _b.call(widget);
    (_c = widget.syncSelectedSummary) == null ? void 0 : _c.call(widget);
    if (emit) emitChange();
  };
  const clearSelectedRadio = (widget, emit = true) => {
    var _a, _b;
    if (!widget) return;
    widget.querySelectorAll(RADIO).forEach((input) => {
      input.checked = false;
    });
    widget.__selectedRadio = null;
    if (typeof widget.syncGroupLabel === "function") {
      widget.syncGroupLabel();
    }
    if (typeof widget.refresh === "function") {
      widget.refresh(emit);
      (_a = widget.setCollapsedState) == null ? void 0 : _a.call(widget, true);
      return;
    }
    syncWidgetSelectionState(widget, emit);
    (_b = widget.setCollapsedState) == null ? void 0 : _b.call(widget, true);
  };
  const setSelectedRadio = (widget, radio, emit = true) => {
    var _a, _b;
    if (!widget || !radio) return;
    widget.querySelectorAll(RADIO).forEach((input) => {
      input.checked = input === radio;
    });
    widget.__selectedRadio = radio;
    if (typeof widget.syncGroupLabel === "function") {
      widget.syncGroupLabel();
    }
    if (typeof widget.refresh === "function") {
      widget.refresh(emit);
      (_a = widget.setCollapsedState) == null ? void 0 : _a.call(widget, true);
      return;
    }
    syncWidgetSelectionState(widget, emit);
    (_b = widget.setCollapsedState) == null ? void 0 : _b.call(widget, true);
  };
  const bindVariantWatcher = () => {
    if (variantWatchBound) return;
    variantWatchBound = true;
    document.addEventListener("variant:change", (event) => {
      var _a;
      const incoming = num((_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.price);
      if (incoming > 0) variantBaseCents = incoming;
      const allWidgets = widgets();
      allWidgets.forEach((widget) => {
        if (typeof widget.syncGroupLabel === "function") {
          widget.syncGroupLabel();
        }
      });
      if (allWidgets.length) {
        emitChange();
        return;
      }
      scheduleNow();
      scheduleLate();
    });
  };
  const bindAvisWatchers = () => {
    if (avisWatchBound) return;
    avisWatchBound = true;
    const target = document.querySelector(".avpoptions-container__v2");
    if (target) {
      const observer = new MutationObserver(scheduleLate);
      observer.observe(target, { childList: true, subtree: true, attributes: true });
    }
    document.body.addEventListener("change", (event) => {
      const targetNode = event.target;
      if (!targetNode || !targetNode.matches) return;
      const avisRadio = targetNode.matches("input[type=radio]") && targetNode.closest(".avpoptions-container__v2");
      if (avisRadio || targetNode.matches(".avp-productoptiontextcolor, .avp-productoptionbackground")) {
        scheduleLate();
      }
    });
  };
  const bindUcaSelectionFallback = () => {
    if (!ucaClickBound) {
      ucaClickBound = true;
      document.addEventListener("click", (event) => {
        var _a, _b, _c, _d;
        const option = (_b = (_a = event.target) == null ? void 0 : _a.closest) == null ? void 0 : _b.call(_a, OPTION);
        if (!option) return;
        const widget = (_d = (_c = event.target) == null ? void 0 : _c.closest) == null ? void 0 : _d.call(_c, ROOT);
        if (!widget) return;
        if (event.target.closest("a, button, select, textarea")) return;
        const radio = option.querySelector(RADIO);
        if (!radio) return;
        const isSameSelection = widget.__selectedRadio === radio;
        event.preventDefault();
        if (isSameSelection) {
          clearSelectedRadio(widget, true);
          return;
        }
        setSelectedRadio(widget, radio, true);
      });
    }
    if (!ucaChangeBound) {
      ucaChangeBound = true;
      document.addEventListener("change", (event) => {
        var _a, _b, _c;
        const target = event.target;
        if (!((_a = target == null ? void 0 : target.matches) == null ? void 0 : _a.call(target, RADIO))) return;
        const widget = target.closest(ROOT);
        if (!widget) return;
        if (typeof widget.syncGroupLabel === "function") {
          widget.syncGroupLabel();
        }
        if (typeof widget.refresh === "function") {
          widget.refresh(true);
          (_b = widget.setCollapsedState) == null ? void 0 : _b.call(widget, true);
          return;
        }
        syncWidgetSelectionState(widget, true);
        (_c = widget.setCollapsedState) == null ? void 0 : _c.call(widget, true);
      });
    }
    if (!ucaKeydownBound) {
      ucaKeydownBound = true;
      document.addEventListener("keydown", (event) => {
        var _a, _b, _c, _d;
        if (event.key !== "Enter" && event.key !== " ") return;
        const option = (_b = (_a = event.target) == null ? void 0 : _a.closest) == null ? void 0 : _b.call(_a, OPTION);
        if (!option) return;
        const widget = (_d = (_c = event.target) == null ? void 0 : _c.closest) == null ? void 0 : _d.call(_c, ROOT);
        const radio = option.querySelector(RADIO);
        if (!widget || !radio) return;
        event.preventDefault();
        if (widget.__selectedRadio === radio) {
          clearSelectedRadio(widget, true);
          return;
        }
        setSelectedRadio(widget, radio, true);
      });
    }
  };
  class UcaAddonsWidget extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ucaInit === "true") return;
      this.dataset.ucaInit = "true";
      this.__onChange = (event) => this.handleChange(event);
      this.__onToggle = () => {
        if (!this.isCollapsible()) return;
        this.setCollapsedState(!this.classList.contains("is-collapsed"));
      };
      this.addEventListener("change", this.__onChange);
      this.bindToggle();
      this.syncGroupLabel();
      this.refresh(false);
      this.setCollapsedState(this.isCollapsible(), { immediate: true });
      emitChange();
    }
    disconnectedCallback() {
      if (this.__onChange) this.removeEventListener("change", this.__onChange);
      if (this.__toggleArea && this.__onToggle) {
        this.__toggleArea.removeEventListener("click", this.__onToggle);
      }
      emitChange();
    }
    isCollapsible() {
      return this.dataset.ucaCollapsible === "true" && Boolean(this.querySelector("[data-uca-toggle]"));
    }
    bindToggle() {
      if (this.dataset.ucaLocalDisclosure === "true") return;
      const toggleArea = this.querySelector("[data-uca-toggle]");
      if (!toggleArea || toggleArea.dataset.ucaToggleBound === "true") return;
      toggleArea.dataset.ucaToggleBound = "true";
      this.__toggleArea = toggleArea;
      toggleArea.addEventListener("click", this.__onToggle);
    }
    setCollapsedState(isCollapsed, options = {}) {
      const collapsible = this.isCollapsible();
      const nextCollapsed = collapsible ? Boolean(isCollapsed) : false;
      const { immediate = false } = options;
      const toggle = this.querySelector("[data-uca-toggle]");
      const toggleContent = this.querySelector("[data-uca-toggle-content]");
      const body = this.querySelector("[data-uca-body]");
      const arrow = this.querySelector("[data-uca-toggle-arrow]");
      this.classList.toggle("is-collapsed", nextCollapsed);
      this.dataset.ucaCollapsed = nextCollapsed ? "true" : "false";
      if (toggle) {
        toggle.hidden = !collapsible;
        toggle.setAttribute("aria-expanded", nextCollapsed ? "false" : "true");
        toggle.classList.toggle("justify-between", nextCollapsed);
        toggle.classList.toggle("justify-end", !nextCollapsed);
      }
      if (toggleContent) {
        toggleContent.hidden = !nextCollapsed;
        toggleContent.classList.toggle("hidden", !nextCollapsed);
      }
      if (body) {
        syncAccordionBody(body, !(collapsible ? nextCollapsed : false), { immediate });
      }
      if (arrow) {
        arrow.classList.toggle("rotate-180", !nextCollapsed);
      }
      this.syncSelectedSummary();
    }
    syncPreview() {
      const container = this.querySelector("[data-uca-preview-images]");
      if (!container) return;
      container.replaceChildren();
      const previews = this.getOptionPreviewSources().slice(0, 3);
      previews.forEach(({ src, alt }) => {
        const thumb = buildPreviewThumb(src, alt);
        if (thumb) container.appendChild(thumb);
      });
      container.hidden = previews.length === 0;
    }
    getOptionPreviewSources() {
      return this.getOptionCards().map((option) => {
        var _a, _b;
        const radio = option.querySelector(RADIO);
        const image = option.querySelector("[data-uca-preview-source] img, [data-uca-preview-source] image, img");
        const id = text((_a = radio == null ? void 0 : radio.dataset) == null ? void 0 : _a.ucaAddonId);
        if (!id || !(image == null ? void 0 : image.getAttribute("src"))) return null;
        return {
          src: image.getAttribute("src"),
          alt: image.getAttribute("alt") || text((_b = radio == null ? void 0 : radio.dataset) == null ? void 0 : _b.ucaAddonLabel)
        };
      }).filter(Boolean);
    }
    syncSelectedSummary() {
      var _a;
      const container = this.querySelector("[data-uca-selected-summary]");
      if (!container) return;
      container.replaceChildren();
      const selectedRadio = this.querySelector(`${RADIO}:checked`);
      const shouldShow = this.isCollapsible() && this.classList.contains("is-collapsed") && text((_a = selectedRadio == null ? void 0 : selectedRadio.dataset) == null ? void 0 : _a.ucaAddonId);
      if (!shouldShow) {
        container.hidden = true;
        container.classList.add("hidden");
        return;
      }
      const option = selectedRadio == null ? void 0 : selectedRadio.closest(OPTION);
      const summary = createSummaryClone(option);
      if (!summary) {
        container.hidden = true;
        container.classList.add("hidden");
        return;
      }
      summary.classList.remove("pointer-events-none");
      summary.classList.add("cursor-pointer");
      summary.setAttribute("role", "button");
      summary.setAttribute("tabindex", "0");
      summary.setAttribute("aria-label", "Deselect selected UCA option");
      summary.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        clearSelectedRadio(this, true);
      });
      summary.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        event.stopPropagation();
        clearSelectedRadio(this, true);
      });
      container.appendChild(summary);
      container.hidden = false;
      container.classList.remove("hidden");
    }
    getOptionCards() {
      return Array.from(this.querySelectorAll(OPTION)).filter(
        (option) => {
          var _a, _b;
          return Boolean(text((_b = (_a = option.querySelector(RADIO)) == null ? void 0 : _a.dataset) == null ? void 0 : _b.ucaAddonId));
        }
      );
    }
    syncGroupLabel() {
      const baseLabel = getUcaBaseLabel(this);
      const nextGroupLabel = getUcaGroupLabelForLift(baseLabel);
      if (!nextGroupLabel) return;
      this.dataset.ucaGroupBaseLabel = baseLabel;
      this.dataset.ucaGroupLabel = nextGroupLabel;
      const title = this.querySelector("[data-uca-group-title]");
      if (title) {
        title.textContent = nextGroupLabel;
      }
      this.querySelectorAll(RADIO).forEach((radio) => {
        radio.dataset.ucaAddonGroup = nextGroupLabel;
      });
    }
    getSelectedItemData() {
      var _a;
      const radio = this.querySelector(`${RADIO}:checked`);
      const id = text((_a = radio == null ? void 0 : radio.dataset) == null ? void 0 : _a.ucaAddonId);
      if (!id) return null;
      return {
        id: num(id),
        quantity: 1,
        priceCents: num(radio.dataset.ucaAddonPrice),
        heading: text(radio.dataset.ucaAddonHeading),
        label: text(radio.dataset.ucaAddonLabel),
        group: text(radio.dataset.ucaAddonGroup) || text(this.dataset.ucaGroupLabel) || getUcaGroupLabelForLift(getUcaBaseLabel(this))
      };
    }
    getSelectedCartItems() {
      const item = this.getSelectedItemData();
      if (!item) return [];
      return [
        {
          id: item.id,
          quantity: item.quantity,
          priceCents: item.priceCents,
          properties: {
            "_Addon Type": "Upper Control Arms",
            "_UCA Group": item.group,
            "_UCA Heading": item.heading,
            "_UCA Option": item.label
          }
        }
      ];
    }
    getSelectedTotalCents() {
      var _a;
      return num((_a = this.getSelectedItemData()) == null ? void 0 : _a.priceCents);
    }
    refresh(emit = true) {
      this.__selectedRadio = this.querySelector(`${RADIO}:checked`) || null;
      this.querySelectorAll(OPTION).forEach((option) => {
        const radio = option.querySelector(RADIO);
        const isSelected = Boolean(radio && radio.checked);
        option.classList.toggle("is-selected", isSelected);
        option.setAttribute("aria-checked", isSelected ? "true" : "false");
      });
      const hidden = this.querySelector(".uca-total-addcharge");
      if (hidden) {
        hidden.value = String(this.getSelectedTotalCents());
      }
      this.syncPreview();
      this.syncSelectedSummary();
      if (emit) emitChange();
    }
    handleChange(event) {
      const target = event.target;
      if (target && target.matches && target.matches(RADIO)) {
        this.refresh(true);
        if (this.isCollapsible()) {
          this.setCollapsedState(true);
        }
      }
    }
  }
  if (!window.customElements.get("uca-addons-widget")) {
    window.customElements.define("uca-addons-widget", UcaAddonsWidget);
  }
  bindVariantWatcher();
  bindAvisWatchers();
  bindUcaSelectionFallback();
  document.addEventListener("custom:moreaddons:change", () => {
    scheduleNow();
    scheduleLate();
  });
  document.addEventListener("front-shock-assembly:addon-change", () => {
    scheduleNow();
    scheduleLate();
  });
  window.MudifyAddonPriceSync = Object.assign(window.MudifyAddonPriceSync || {}, {
    formatMoney,
    hasAddonRuntime,
    getVariantBaseCents: variantBase,
    getAvisTotalCents: avisTotal,
    getUcaTotalCents: selectedTotal,
    getTireTotalCents: tireTotal,
    getMoreAddonsTotalCents: moreAddonsTotal,
    getFrontShockAssemblyTotalCents: frontShockAssemblyTotal,
    getCombinedDisplayCents: combinedTotal,
    applyCombinedPrice
  });
  window.UCAAddons = {
    refresh,
    getSelectedCartItems: selectedItems,
    getSelectedTotalCents: selectedTotal,
    emitChange
  };
  if (!window.__lastUcaAddonChange) {
    window.__lastUcaAddonChange = { items: [], totalCents: 0 };
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleLate, { once: true });
  } else {
    scheduleLate();
  }
})();
